import React, { useEffect, useState } from 'react'
import "./attributes.css"
import { formatToRupees, isValidNumeric, valueEmptyNonEmptyHandler } from 'utlis/utils'

const RoomRentMetroNonMetro = ({ data, selectionHandler }) => {
    const [maternityListData, setMaternityListData] = useState([])

    const maternityDataFormatter = (data) => {
        let result = []
        let keyName = selectionHandler.replace(" ", "_").toLowerCase();
        let metroNonMetroObjSelection = data.values[keyName]

        result.push({
            heading: "Normal",
            section1: "Percentage of SI per day Limit",
            section1Value: metroNonMetroObjSelection["normal"].percentage ? `${metroNonMetroObjSelection["normal"].percentage}%` : "-",
            section2: "Max Per Day",
            section2Value: valueEmptyNonEmptyHandler(metroNonMetroObjSelection["normal"].max),
            remarks: metroNonMetroObjSelection["remarks"] ? metroNonMetroObjSelection["remarks"] : "-"
        })
 
        result.push({
            heading: "ICU",
            section1: "Percentage of SI per day Limit",
            section1Value: metroNonMetroObjSelection["icu"].percentage ? `${metroNonMetroObjSelection["icu"].percentage}%` : "-",
            section2: "Max Per Day",
            section2Value: valueEmptyNonEmptyHandler(metroNonMetroObjSelection["icu"].max),
            remarks: metroNonMetroObjSelection["remarks"] ? metroNonMetroObjSelection["remarks"] : "-"
        })

        setMaternityListData(result)
    }

    useEffect(() => {
        maternityDataFormatter(data)
    }, [selectionHandler])

    return (
        <div style={{ display: "flex", gap: "24px", overflow: "scroll", width: "100%"}}>
            {maternityListData.map((each_obj, objKey) => (
                 <>
                    <div className="maternity-card-css" key={objKey}>
                        <div class="spacing-css">
                            <div>
                                <span className="maternity-card-heading-css">
                                    {each_obj.heading}
                                </span>
                            </div>
                            <div className="gold-line-css" />
                        </div>

                        <div style={{ display: "flex", flexDirection: "column", marginTop: "16px", gap: "8px" }}>
                            <span className='maternity-max-limit-heading'>
                                {each_obj.section1}
                            </span>
                            <span className='maternity-max-limit-value'>
                                {each_obj.section1Value}
                            </span>
                        </div>
        
                        <div style={{ display: "flex", flexDirection: "column", marginTop: "16px", gap: "8px" }}>
                            <span className='maternity-max-limit-heading'>
                                {each_obj.section2}
                            </span>
                            <span className='maternity-max-limit-value'>
                                {each_obj.section2Value}
                            </span>
                        </div>

                        <div style={{ display: "flex", flexDirection: "column", marginTop: "14px", gap: "8px" }}>
                            <span className='maternity-max-limit-heading'>
                                Remarks
                            </span>
                            <span className='maternity-max-limit-value'>
                                {each_obj.remarks}
                            </span>
                        </div>

                    </div>
                </>
            ))}
        </div>
    )
}

export default RoomRentMetroNonMetro
